module.exports = __webpack_public_path__ + "img/rc-active.501cf570.png";